import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'availableStudentsForTeam'
})
export class AvailableStudentsForTeamPipe implements PipeTransform {
  public transform(users: { id: number; teamId: number; displayName: string }[], userShowMode: 'all' | 'selected', teamId: number): number {
    return users.filter(user => (userShowMode === 'all' || (user.teamId !== -1 && teamId === user.teamId))).length;
  }
}
